/**
 * pages/erga-archive.js — Έργα archive / taxonomy grid
 *
 * Progressively enhances the filter + pagination links (.js-erga-nav,
 * real URLs to /erga/ and /erga-category/...) into an in-place fetch +
 * swap of #erga-results, with a skeleton while loading and
 * history.pushState so the address bar always matches what's on screen.
 *
 * Deliberately NOT a custom AJAX endpoint: it fetches the exact same
 * normal, cacheable WordPress URL a full page load would use, so:
 *  - it works with JS disabled (plain navigation),
 *  - the URL is always real, shareable and reload-safe,
 *  - responses are cached the same way any other page view is.
 */

(function () {
    var resultsEl  = document.getElementById('erga-results');
    var skeletonEl = document.getElementById('erga-skeleton');
    var filtersEl  = document.getElementById('erga-filters');

    if (!resultsEl) {
        return;
    }

    function loadUrl(url) {
        if (skeletonEl) {
            skeletonEl.classList.remove('hidden');
        }
        resultsEl.classList.add('hidden');

        fetch(url)
            .then(function (res) {
                return res.text();
            })
            .then(function (html) {
                var doc         = new DOMParser().parseFromString(html, 'text/html');
                var newResults  = doc.getElementById('erga-results');
                var newFilters  = doc.getElementById('erga-filters');

                if (newResults) {
                    resultsEl.innerHTML = newResults.innerHTML;
                }

                // Swap the filter pills too, so "active" styling always
                // matches the server-rendered state for this exact URL —
                // no separate client-side active-state bookkeeping needed.
                if (newFilters && filtersEl) {
                    filtersEl.innerHTML = newFilters.innerHTML;
                }

                if (doc.title) {
                    document.title = doc.title;
                }

                resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
            .catch(function () {
                // Fetch failed (offline, etc.) — fall back to a real navigation.
                window.location.href = url;
            })
            .finally(function () {
                if (skeletonEl) {
                    skeletonEl.classList.add('hidden');
                }
                resultsEl.classList.remove('hidden');
            });
    }

    document.addEventListener('click', function (e) {
        var link = e.target.closest('.js-erga-nav');
        if (!link) {
            return;
        }

        e.preventDefault();
        var url = link.getAttribute('href');
        window.history.pushState({ ergaUrl: url }, '', url);
        loadUrl(url);
    });

    window.addEventListener('popstate', function () {
        loadUrl(window.location.href);
    });
})();
